export const INSTITUTION = 'Shalamar Medical & Dental College';

/** Fallback only — the live address comes from the API config. */
export const IRB_EMAIL = 'irb@sihs.org.pk';

export const REVIEW_CATEGORIES = [
  'Urgent',
  'Expedited',
  'Exempted',
  'Routine'
] as const;

/**
 * The research-type list and the document checklist are no longer hard-coded:
 * they come from Web_Students.dbo.ResTypes and ResearchDocuments through
 * GET api/Research/Config, so the IRB Secretariat can change them without a
 * front-end release. See PortalContext.config.
 */
